module.exports = __webpack_public_path__ + "static/media/20ECE8.9ba33820.jpg";